import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M16.375 10.438c0 1.257-.41 2.433-1.094 3.363l3.446 3.472a.843.843 0 0 1 0 1.23.843.843 0 0 1-1.23 0l-3.474-3.472c-.93.711-2.105 1.094-3.335 1.094A5.683 5.683 0 0 1 5 10.438C5 7.32 7.543 4.75 10.688 4.75c3.117 0 5.687 2.57 5.687 5.688m-5.687 3.937c1.394 0 2.68-.738 3.39-1.969a3.9 3.9 0 0 0 0-3.937c-.71-1.203-1.996-1.969-3.39-1.969A3.97 3.97 0 0 0 7.27 8.469a3.9 3.9 0 0 0 0 3.937 3.92 3.92 0 0 0 3.418 1.969"
    }, null, -1)
  ]))]))
}
export default { render: render }